import axios from 'axios';

const api = axios.create({
    baseURL: 'https://simm-api.azure-api.net/api/v1/',
    // baseURL: 'https://localhost:7118/api/v1/',
    headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': '085ff9b911804925bb3573b0cb22e5e7',
    },
    timeout: 10000,
});

// Sesión expirada/inválida: cualquier llamada a la API que devuelva 401 limpia
// la sesión guardada y manda al usuario al login, sin importar en qué pantalla
// esté. Centralizado acá (en vez de en cada página) porque todas las llamadas
// pasan por esta única instancia de axios (Principio III de la constitución).
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            sessionStorage.removeItem('simm_user');
            if (window.location.pathname !== '/auth/login') {
                window.location.href = '/auth/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;